<h2 mat-dialog-title><b>Images in trash older than 30 days found</b></h2>
<mat-dialog-content>
    <p>Starting with version 3.25.0 (from June 24, 2025), images that have been in the trash for over 30 days will be automatically deleted.</p>
    <p>You're seeing this message because you currently have such images.</p>
    <p><b>What to do now:</b></p>
    Permanently delete them if you're sure you are not using them anymore, or recover them if you still need them — so you won't lose anything unexpectedly.
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close color="primary">Ok, I understand</button>
</mat-dialog-actions>